export const messages = {
  en: {
    orderDetail: {
      title: 'Confirm Outbound',
      productInfo: 'Product Information',
      orderCode: 'Order Code',
      applicant: 'Applicant',
      applyTime: 'Apply Time',
      orderStatus: 'Order Status',
      remark: 'Remark',
      productName: 'Product Name',
      productCode: 'Product Code',
      specification: 'Specification',
      applyQuantity: 'Apply Quantity',
      actualQuantity: 'Actual Quantity',
      price: 'Price',
      amount: 'Amount',
      operation: 'Operation',
      cancelOutbound: 'Cancel Outbound',
      canceled: 'Canceled',
      confirmOutbound: 'Confirm Outbound',
      cancelOrder: 'Cancel Order',
      back: 'Back'
    }
  },
  zh: {
    orderDetail: {
      title: '确定出库',
      productInfo: '商品信息',
      orderCode: '工单编码',
      applicant: '申请人',
      applyTime: '申请时间',
      orderStatus: '订单状态',
      remark: '备注',
      productName: '商品名称',
      productCode: '商品编号',
      specification: '规格',
      applyQuantity: '申请单数量',
      actualQuantity: '实际出库数量',
      price: '价格',
      amount: '金额',
      operation: '操作',
      cancelOutbound: '取消出库',
      canceled: '已取消',
      confirmOutbound: '确定出库',
      cancelOrder: '取消出库单',
      back: '返回'
    }
  }
}